import { render, staticRenderFns } from "./widgetMarquee.vue?vue&type=template&id=7a1feba8&scoped=true&"
import script from "./widgetMarquee.vue?vue&type=script&lang=js&"
export * from "./widgetMarquee.vue?vue&type=script&lang=js&"
import style0 from "./widgetMarquee.vue?vue&type=style&index=0&id=7a1feba8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1feba8",
  null
  
)

export default component.exports